/**
 * The enum for `update_status` property of `Address` data.
 */
export var UpdateStatus;
(function (UpdateStatus) {
    /**
     * The record is not modified.
     */
    UpdateStatus[UpdateStatus["NONE"] = 0] = "NONE";
    /**
     * The record is modified.
     */
    UpdateStatus[UpdateStatus["UPDATED"] = 1] = "UPDATED";
    /**
     * The record is marked as no longer valid.
     */
    UpdateStatus[UpdateStatus["ABOLISHED"] = 2] = "ABOLISHED";
})(UpdateStatus || (UpdateStatus = {}));
/**
 * The enum for `update_reason` property of `Address` data.
 */
export var UpdateReason;
(function (UpdateReason) {
    /**
     * The record is not modified.
     */
    UpdateReason[UpdateReason["NONE"] = 0] = "NONE";
    /**
     * The city where the area to which this record was assigned previously belongs
     * was merged with other cities.
     */
    UpdateReason[UpdateReason["REDESIGNATED"] = 1] = "REDESIGNATED";
    /**
     * The district to which this record is assigned had gone through address
     * reorganization, such as designation as a building-based addressing area.
     */
    UpdateReason[UpdateReason["ADDRESSING_SYSTEM_RENEWAL"] = 2] = "ADDRESSING_SYSTEM_RENEWAL";
    /**
     * The district to which this record is assigned had gone through area
     * reorganization.
     */
    UpdateReason[UpdateReason["READJUSTMENT"] = 3] = "READJUSTMENT";
    /**
     * The area or its districts weren't changed, but the postal codes
     * were reassigned.
     */
    UpdateReason[UpdateReason["REASSIGNMENT"] = 4] = "REASSIGNMENT";
    /**
     * The record contained some errors and was amended.
     */
    UpdateReason[UpdateReason["AMENDMENT"] = 5] = "AMENDMENT";
    /**
     * The record is marked as no longer valid.
     */
    UpdateReason[UpdateReason["ABOLISHED"] = 6] = "ABOLISHED";
})(UpdateReason || (UpdateReason = {}));
/**
 * An `NTACorporateInfoProcess` represents the reason why the record
 * was added.
 */
export var NTACorporateInfoProcess;
(function (NTACorporateInfoProcess) {
    /**
     * Indicates new record.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["NEW"] = 1] = "NEW";
    /**
     * Indicates trade name or corporate name was changed.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["NAME_CHANGED"] = 11] = "NAME_CHANGED";
    /**
     * Indicates domestic address was changed.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["DOMESTIC_ADDRESS_CHANGED"] = 12] = "DOMESTIC_ADDRESS_CHANGED";
    /**
     * Indicates overseas address was changed.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["OVERSEAS_ADDRESS_CHANGED"] = 13] = "OVERSEAS_ADDRESS_CHANGED";
    /**
     * Indicates registration record was closed.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["REGISTRATION_RECORD_CLOSED"] = 21] = "REGISTRATION_RECORD_CLOSED";
    /**
     * Indicates registration record was reopened.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["REGISTRATION_RECORD_REOPENED"] = 22] = "REGISTRATION_RECORD_REOPENED";
    /**
     * Indicates absorption merger completed.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["ABSORPTION_MERGER_COMPLETED"] = 71] = "ABSORPTION_MERGER_COMPLETED";
    /**
     * Indicates absorption merger was invalidated.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["ABSORPTION_MERGER_INVALIDATED"] = 72] = "ABSORPTION_MERGER_INVALIDATED";
    /**
     * Indicates registration record was erased.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["REGISTRATION_RECORD_ERASED"] = 81] = "REGISTRATION_RECORD_ERASED";
    /**
     * Indicates the record was deleted.
     */
    NTACorporateInfoProcess[NTACorporateInfoProcess["DELETED"] = 99] = "DELETED";
})(NTACorporateInfoProcess || (NTACorporateInfoProcess = {}));
/**
 * An `NTACorporateInfoKind` represents the kind of corporate.
 */
export var NTACorporateInfoKind;
(function (NTACorporateInfoKind) {
    /**
     * National public entity
     */
    NTACorporateInfoKind[NTACorporateInfoKind["NATIONAL_PUBLIC_ENTITY"] = 101] = "NATIONAL_PUBLIC_ENTITY";
    /**
     * Local public entity
     */
    NTACorporateInfoKind[NTACorporateInfoKind["LOCAL_PUBLIC_ENTITY"] = 201] = "LOCAL_PUBLIC_ENTITY";
    /**
     * Limited liability company by share, aka K.K.
     */
    NTACorporateInfoKind[NTACorporateInfoKind["KABUSHIKI_KAISHA"] = 301] = "KABUSHIKI_KAISHA";
    /**
     * Old style of limited liability company not by share
     */
    NTACorporateInfoKind[NTACorporateInfoKind["YUGEN_KAISHA"] = 302] = "YUGEN_KAISHA";
    /**
     * General partnership company
     */
    NTACorporateInfoKind[NTACorporateInfoKind["GOMEI_KAISHA"] = 303] = "GOMEI_KAISHA";
    /**
     * Limited partnership company
     */
    NTACorporateInfoKind[NTACorporateInfoKind["GOSHI_KAISHA"] = 304] = "GOSHI_KAISHA";
    /**
     * Limited liability company, aka G.K.
     */
    NTACorporateInfoKind[NTACorporateInfoKind["GODO_KAISHA"] = 305] = "GODO_KAISHA";
    /**
     * Other types of company
     */
    NTACorporateInfoKind[NTACorporateInfoKind["OTHER_COMPANY"] = 399] = "OTHER_COMPANY";
    /**
     * Foreign company
     */
    NTACorporateInfoKind[NTACorporateInfoKind["FOREIGN_COMPANY"] = 401] = "FOREIGN_COMPANY";
    /**
     * Other corporate kinds which do not belong to the above
     */
    NTACorporateInfoKind[NTACorporateInfoKind["OTHER"] = 499] = "OTHER";
})(NTACorporateInfoKind || (NTACorporateInfoKind = {}));
/**
 * An `NTACorporateInfoCloseCause` represents the reason why the corporate
 * was closed.
 */
export var NTACorporateInfoCloseCause;
(function (NTACorporateInfoCloseCause) {
    /**
     *  Liquidation completed
     */
    NTACorporateInfoCloseCause["LIQUIDATION_COMPLETED"] = "1";
    /**
     *  Dissolution by merger
     */
    NTACorporateInfoCloseCause["DISSOLUTION_BY_MERGER"] = "11";
    /**
     *  A registerer closed the corporate
     */
    NTACorporateInfoCloseCause["CLOSED_BY_REGISTERER"] = "21";
    /**
     *  Other reasons
     */
    NTACorporateInfoCloseCause["OTHER"] = "31";
})(NTACorporateInfoCloseCause || (NTACorporateInfoCloseCause = {}));
/**
 * An `NTAQualifiedInvoiceIssuerProcess` specifies the state of the registration.
 */
export var NTAQualifiedInvoiceIssuerProcess;
(function (NTAQualifiedInvoiceIssuerProcess) {
    /**
     * Implies that the record is newly registered.
     */
    NTAQualifiedInvoiceIssuerProcess[NTAQualifiedInvoiceIssuerProcess["NEW"] = 1] = "NEW";
    /**
     * Implies that the record has been changed.
     */
    NTAQualifiedInvoiceIssuerProcess[NTAQualifiedInvoiceIssuerProcess["INFORMATION_CHANGED"] = 2] = "INFORMATION_CHANGED";
    /**
     * Implies that the registration has been expired.
     */
    NTAQualifiedInvoiceIssuerProcess[NTAQualifiedInvoiceIssuerProcess["REGISTRATION_EXPIRED"] = 3] = "REGISTRATION_EXPIRED";
    /**
     * Implies that the registration has been invalidated.
     */
    NTAQualifiedInvoiceIssuerProcess[NTAQualifiedInvoiceIssuerProcess["REGISTRATION_DISPOSED"] = 4] = "REGISTRATION_DISPOSED";
    /**
     * Implies that the registration has been deleted.
     */
    NTAQualifiedInvoiceIssuerProcess[NTAQualifiedInvoiceIssuerProcess["DELETED"] = 99] = "DELETED";
})(NTAQualifiedInvoiceIssuerProcess || (NTAQualifiedInvoiceIssuerProcess = {}));
/**
 * An `NTAQualifiedInvoiceIssuerCorrect` implies the reason for the change,
 * if the record has been updated.
 */
export var NTAQualifiedInvoiceIssuerCorrect;
(function (NTAQualifiedInvoiceIssuerCorrect) {
    /**
     * Not the correction.
     */
    NTAQualifiedInvoiceIssuerCorrect[NTAQualifiedInvoiceIssuerCorrect["OTHER"] = 0] = "OTHER";
    /**
     * Correction.
     */
    NTAQualifiedInvoiceIssuerCorrect[NTAQualifiedInvoiceIssuerCorrect["CORRECTION"] = 1] = "CORRECTION";
})(NTAQualifiedInvoiceIssuerCorrect || (NTAQualifiedInvoiceIssuerCorrect = {}));
/**
 * An `NTAQualifiedInvoiceIssuerKind` specifies the kind of the invoice issuer.
 */
export var NTAQualifiedInvoiceIssuerKind;
(function (NTAQualifiedInvoiceIssuerKind) {
    /**
     * Implies that the record is for a sole proprietor.
     */
    NTAQualifiedInvoiceIssuerKind[NTAQualifiedInvoiceIssuerKind["INDIVIDUAL"] = 1] = "INDIVIDUAL";
    /***
     * Implies that the record is for a corporate entity.
     */
    NTAQualifiedInvoiceIssuerKind[NTAQualifiedInvoiceIssuerKind["CORPORATION"] = 2] = "CORPORATION";
})(NTAQualifiedInvoiceIssuerKind || (NTAQualifiedInvoiceIssuerKind = {}));
/**
 * An `NTAQualifiedInvoiceIssuerCountry` specifies whether the issuing entity is domestic or not,
 * and if domestic, whether it is specifically designated by the National Tax Agency.
 */
export var NTAQualifiedInvoiceIssuerCountry;
(function (NTAQualifiedInvoiceIssuerCountry) {
    /**
     * Implies that the record is for a domestic entity
     */
    NTAQualifiedInvoiceIssuerCountry[NTAQualifiedInvoiceIssuerCountry["DOMESTIC_ENTITY"] = 1] = "DOMESTIC_ENTITY";
    /**
     * Implies that the record is for a designated foreign entity.
     */
    NTAQualifiedInvoiceIssuerCountry[NTAQualifiedInvoiceIssuerCountry["DESIGNATED_FOREIGN_ENTITY"] = 2] = "DESIGNATED_FOREIGN_ENTITY";
    /**
     * Implies that the record is for a general (not specifically designated) foreign entity.
     */
    NTAQualifiedInvoiceIssuerCountry[NTAQualifiedInvoiceIssuerCountry["GENERAL_FOREIGN_ENTITY"] = 3] = "GENERAL_FOREIGN_ENTITY";
})(NTAQualifiedInvoiceIssuerCountry || (NTAQualifiedInvoiceIssuerCountry = {}));
/**
 * An `NTAQualifiedInvoiceIssuerUpdateStatus` specifies whether the record is latest or obsolete.
 */
export var NTAQualifiedInvoiceIssuerUpdateStatus;
(function (NTAQualifiedInvoiceIssuerUpdateStatus) {
    /**
     * Implies that the record is obsolete
     */
    NTAQualifiedInvoiceIssuerUpdateStatus[NTAQualifiedInvoiceIssuerUpdateStatus["OBSOLETE"] = 0] = "OBSOLETE";
    /**
     * Implies that the record is the latest one.
     */
    NTAQualifiedInvoiceIssuerUpdateStatus[NTAQualifiedInvoiceIssuerUpdateStatus["LATEST"] = 1] = "LATEST";
})(NTAQualifiedInvoiceIssuerUpdateStatus || (NTAQualifiedInvoiceIssuerUpdateStatus = {}));
//# sourceMappingURL=interfaces.v20240101.js.map